<template>
  <div class="ex-home">
    <div class="eh-top" v-if="false">
      <div class="eh-top-l">
        <div class="logo">
          <img :src="company.logo" v-if="company.logo" />
          <img src="@assets/img/empty.png" v-else />
        </div>
        <div class="info">
          <div class="info-title">{{company.name}}</div>
          <div class="info-txt">注册时间：{{company.inTime | moment("YYYY/MM/DD")}}</div>
        </div>
      </div>
      <div class="eh-top-r" v-if="false">
        <p>账户余额：550元</p>
      </div>
    </div>
    <div class="eh-content" v-if="false">
      <div class="info-list">
        <div class="info-list-item">
          <div class="info-list-item__top">
            <img src="@assets/img/avatar.png" />
          </div>
          <div class="info-list-item__txt">展商管理</div>
        </div>
        <div class="info-list-item" v-if="false">
          <div class="info-list-item__top">
            <div class="info-list-item__txt2">359</div>
          </div>
          <div class="info-list-item__txt">全部</div>
        </div>
        <div class="info-list-item" v-if="false">
          <div class="info-list-item__top">
            <div class="info-list-item__txt2 s-red">2</div>
          </div>
          <div class="info-list-item__txt">未报馆</div>
        </div>
      </div>
    </div>
    <div class="eh-empty">
      <!-- <template v-if="company && company.name">{{company.name}},</template> -->
      欢迎回来
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "host-home",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany"
    })
  }
};
</script>

<style scoped lang="scss">
.ex-home {
  min-height: 500px;
  background-color: #fff;
  padding: 20px 30px;
  .eh {
    &-top {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      &-l {
        width: 50%;
        display: flex;
        align-items: center;
        .logo {
          width: 56px;
          height: 56px;
          border: 1px solid #d8d8d8;
          border-radius: 5px;
          overflow: hidden;
          img {
            width: 56px;
            height: 56px;
          }
        }
        .info {
          padding-left: 20px;
          &-title {
            font-size: 14px;
            color: #333;
            font-weight: bold;
            margin-bottom: 10px;
            width: 200px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          &-txt {
            font-size: 12px;
            color: #4d4d4d;
          }
        }
      }
      &-r {
        width: 50%;
        p {
          text-align: right;
          font-size: 36px;
          color: #333;
          font-weight: bold;
        }
      }
    }
    &-content {
      .info-list {
        display: flex;
        text-align: center;
        &-item {
          width: 150px;
          height: 200px;
          background-color: #f5f7fb;
          padding-top: 20px;
          &:first-child {
            background-color: #118eea;
            color: #fff;
            .info-list-item__txt {
              color: #fff;
            }
          }
          &__top {
            width: 100px;
            height: 100px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto;
          }
          &__txt2 {
            font-size: 24px;
            color: #333;
            font-weight: bold;
            &.s-red {
              color: #fc1d1d;
            }
          }
          &__txt {
            font-size: 20px;
            color: #808080;
          }
        }
      }
    }
    &-empty {
      height: 500px;
      text-align: center;
      line-height: 500px;
      font-size: 30px;
    }
  }
}
</style>
